module.exports = __webpack_public_path__ + "img/balanceBg-mobile.66aaa88b.png";